export default "__VITE_ASSET__CDZ1VEL5__"